import React from 'react';
import styled from 'styled-components';
import Button from './Button';
import PText from './PText';
import SectionTitle from './SectionTitle';
// import AboutImg from '../assets/images/about-sec-img.png';
// import { Link } from 'react-router-dom';
// import Cube from './Cube';
import BParticles from './BParticles';

const AboutSectionStyles = styled.div`
  padding:  0;
  .container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
  }
    .aboutSection__left {
        flex: 4;
      }
    .aboutSection__right {
      flex: 3;
    }
  .section-title {
    text-align: left;
  }
  .para {
    margin-top: 2rem;
    margin-left: 0;
  }
  .aboutSection__buttons {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 2rem;
    margin-top: 2rem;
  }
  .aboutImg{
    border:2px solid var(--primary);
  }

  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      justify-content:center;
      align-items:center;
    }
    .aboutSection__left,
    .aboutSection__right {
      width: 100%;
    }
    .section-title{
      text-align:center;
    }
    .aboutSection__buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2rem;
      margin-top: 2rem;
    }
    .aboutSection__right {
      margin-top: 3rem;
    }

    .para {
      margin-top: 2rem;
    }

  }
`;

export default function AboutSection() {
  return (
    <AboutSectionStyles>
      <BParticles/>
      <div className="container">
        <div className="aboutSection__left">
          <SectionTitle
            subheading="a little about myself"
            heading="about"
          />
          <PText>
    I’m living the dream. I’ve always been a problem solver, an independent introvert, and a technophile obsessed with the latest devices. 
    Today, I’m working from home as a software engineer for Expedia Group, and I get to show off all these elements of who I am.
          </PText>
          <div className="aboutSection__buttons">
            <Button btnText="Projects" btnLink="/projects" />

            <Button btnText="Resume" outline btnLink="https://ojasvishaklya.github.io/resume/" />

          </div>
        </div>
        <div className="aboutSection__right">
          {/* <img className="aboutImg" src={AboutImg} alt="Img" /> */}
        </div>
      </div>
    </AboutSectionStyles>
  );
}
